// 생성 파일 — 손으로 고치지 않는다. 원문 `tools/policy-sources/terms-2026-09-22.en.txt`, 변환 `tools/make-policy-docs.py`.
import type { PolicyDoc } from '../../policyDoc';

export const terms20260922En: PolicyDoc = {
  title: 'Terms of service',
  articles: [
    {
      title: 'Article 1 (Purpose)',
      blocks: [
        {
          type: 'p',
          text: 'These terms set out the conditions and procedures for using MUZLY (the "Service"), the vocal diagnosis service provided by MUZLY (the "Company"), and the rights, duties and responsibilities of the Company and its users.',
        },
      ],
    },
    {
      title: 'Article 2 (Definitions)',
      blocks: [
        {
          type: 'p',
          text: '1. "Service" means every app and web feature that records and analyses your voice and reports range, pitch, breath, tone and related metrics and results.',
        },
        {
          type: 'p',
          text: '2. "User" means anyone who uses the Service under these terms.',
        },
        {
          type: 'p',
          text: '3. "Recordings" means the voice you record in the Service for a diagnosis and the analysis of it.',
        },
      ],
    },
    {
      title: 'Article 3 (Posting and changes)',
      blocks: [
        {
          type: 'p',
          text: '1. The Company posts these terms in the Service.',
        },
        {
          type: 'p',
          text: '2. The Company may revise these terms within the bounds of applicable law and announces a revision in the Service 7 days before it takes effect, or 30 days before if it is unfavourable to users.',
        },
        {
          type: 'p',
          text: '3. Continuing to use the Service after a revision takes effect means you accept it. If you do not, you may stop using the Service.',
        },
      ],
    },
    {
      title: 'Article 4 (Agreement)',
      blocks: [
        {
          type: 'p',
          text: 'The agreement is formed when you install or open the Service, accept these terms and start using it. No account sign-up is required.',
        },
      ],
    },
    {
      title: 'Article 5 (Provision and changes)',
      blocks: [
        {
          type: 'p',
          text: '1. The Company provides vocal diagnosis, results and session-by-session progress, and other features it decides on, free of charge.',
        },
        {
          type: 'p',
          text: '2. The Company may change the Service for operational or technical reasons and announces significant changes in the Service in advance.',
        },
      ],
    },
    {
      title: 'Article 6 (Suspension)',
      blocks: [
        {
          type: 'p',
          text: 'The Company may pause the Service for maintenance, outages, network failures, natural disasters or similar unavoidable causes. If the Company ends the Service for business reasons, it announces this in the Service 30 days in advance.',
        },
      ],
    },
    {
      title: 'Article 7 (Nature of results)',
      blocks: [
        {
          type: 'p',
          text: '1. Diagnosis results are reference information produced by automated analysis of your recordings. They do not replace medical diagnosis, treatment or a professional assessment.',
        },
        {
          type: 'p',
          text: '2. Results may vary with the device, microphone, background noise, your vocal condition and other recording conditions.',
        },
        {
          type: 'p',
          text: '3. If you notice a problem with your voice or vocal organs, please consult a medical professional.',
        },
      ],
    },
    {
      title: 'Article 8 (Recordings and rights)',
      blocks: [
        {
          type: 'p',
          text: '1. You keep the rights to your recordings.',
        },
        {
          type: 'p',
          text: '2. You agree that the Company stores and analyses your recordings to provide results, play them back, and improve the Service and the accuracy of its analysis. The Company does not use recordings beyond these purposes or share them with third parties.',
        },
        {
          type: 'p',
          text: '3. Copyright and other intellectual property in the Service belong to the Company.',
        },
      ],
    },
    {
      title: 'Article 9 (Privacy)',
      blocks: [
        {
          type: 'p',
          text: 'The Company protects your personal information under applicable law. Collection, use, retention and deletion of personal information follow the Privacy Policy.',
        },
      ],
    },
    {
      title: 'Article 10 (User obligations)',
      blocks: [
        {
          type: 'p',
          text: 'You must not:',
        },
        {
          type: 'p',
          text: "1. Record and diagnose another person's voice without their consent",
        },
        {
          type: 'p',
          text: '2. Reverse-engineer, copy or modify the Service, or disrupt its normal operation',
        },
        {
          type: 'p',
          text: '3. Violate applicable law or these terms',
        },
      ],
    },
    {
      title: 'Article 11 (Restriction and termination)',
      blocks: [
        {
          type: 'p',
          text: '1. You may stop using the Service at any time by deleting the app, and may ask support@muzly.io to delete the recordings and profile stored on our servers.',
        },
        {
          type: 'p',
          text: '2. The Company may restrict use of the Service if you breach Article 10.',
        },
      ],
    },
    {
      title: 'Article 12 (Limitation of liability)',
      blocks: [
        {
          type: 'p',
          text: "1. The Company is not liable for damage caused by force majeure, such as natural disasters, or by the user's own fault.",
        },
        {
          type: 'p',
          text: '2. Unless the Company acted intentionally or with gross negligence, it is not liable for decisions you make based on the results or their consequences.',
        },
        {
          type: 'p',
          text: '3. The Service is free, and to the extent permitted by law the Company is not liable for damage arising from use of the free Service.',
        },
      ],
    },
    {
      title: 'Article 13 (Contact)',
      blocks: [
        {
          type: 'p',
          text: 'Questions about the Service or these terms can be sent to support@muzly.io.',
        },
      ],
    },
    {
      title: 'Article 14 (Governing law and jurisdiction)',
      blocks: [
        {
          type: 'p',
          text: 'These terms are governed by the laws of the Republic of Korea. Disputes about the Service are resolved in the court with jurisdiction under the Civil Procedure Act.',
        },
      ],
    },
    {
      title: 'Addendum',
      blocks: [
        {
          type: 'p',
          text: 'These terms take effect on September 22, 2026.',
        },
      ],
    },
  ],
};
